<div class="modal-header no-print" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">print</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Notas Fiscais de Saída - prévia do relatório</h2>
    <span class="modal-subtitle">{{ data.rotuloPeriodo }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content modal-print-container">
  @if (isCarregando) {
    <div class="no-print">
      <app-loading-box width="100%" height="280"></app-loading-box>
    </div>
  } @else {
    <!-- Cabeçalho do papel: a janela de impressão leva só este bloco. -->
    <div class="nfs-print-cabecalho">
      @if (logoUrl) {
        <img class="nfs-print-logo" [src]="logoUrl" alt="Logo da empresa" />
      }
      <div>
        <h3>Notas Fiscais de Saída</h3>
        <div class="nfs-print-subtitulo">
          {{ data.rotuloPeriodo }} - Emitido em {{ emitidoEm | date: 'dd/MM/yyyy HH:mm' }}
        </div>
      </div>
    </div>

    @if (isTruncado) {
      <!-- Aviso sobre a impressão, não dado dela: some no papel. -->
      <app-alert-card type="warning" class="no-print nfs-print-aviso">
        A listagem tem {{ totalRegistros }} notas e o relatório traz as {{ tetoImpressao }} mais recentes. Reduza o
        período ou aplique mais filtros para imprimir tudo.
      </app-alert-card>
    }

    <table mat-table [dataSource]="notas" class="nfs-print-tabela">
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef>Número</th>
        <td mat-cell *matCellDef="let nota">{{ numero(nota) }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let nota">Saída</td>
      </ng-container>

      <ng-container matColumnDef="dataEmissao">
        <th mat-header-cell *matHeaderCellDef>Data emissão</th>
        <td mat-cell *matCellDef="let nota">{{ nota.dataEmissao | date: 'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let nota">{{ cliente(nota) }}</td>
      </ng-container>

      <ng-container matColumnDef="uf">
        <th mat-header-cell *matHeaderCellDef>UF</th>
        <td mat-cell *matCellDef="let nota">{{ nota.ufDestinatario || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let nota">{{ status(nota) }}</td>
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef class="text-end">Valor (R$)</th>
        <td mat-cell *matCellDef="let nota" class="text-end">{{ nota.valorTotal || 0 | abnt: 'preco' : 2 }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunas"></tr>
      <tr mat-row *matRowDef="let nota; columns: colunas"></tr>
    </table>

    <!-- Totais fora da tabela para não virarem uma linha do mat-table. -->
    <div class="nfs-print-total">
      <span>{{ notas.length }} notas</span>
      <span>Valor total (R$)</span>
      <strong>{{ valorTotal | abnt: 'preco' : 2 }}</strong>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer no-print">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
  <button
    mat-flat-button
    type="button"
    class="btn-primary"
    [disabled]="isCarregando || notas.length === 0"
    (click)="imprimir()">
    <mat-icon class="material-symbols-outlined">print</mat-icon>
    Imprimir
  </button>
</mat-dialog-actions>
